<input
  type="checkbox"
  (click)="handleClick($event)"
  [value]="checkboxValue"
  [disabled]="disabled"
  [checked]="true"
  *ngIf="value == checkboxValue"
/>
<input
  type="checkbox"
  (click)="handleClick($event)"
  [value]="checkboxValue"
  [disabled]="disabled"
  [checked]="false"
  *ngIf="value != checkboxValue"
/>
